<template>
    <relapse-prevention-plan v-if="!!relapsePreventionPlans && relapsePreventionPlans.length > 0"
                             :key="pageKey"
                             v-model="relapsePreventionPlans[curPlan]"
                             :patient-id="patientId"
                             :edit-state="editState"
                             :component-key="componentKey"
                             :flat="false"
                             :url-head="urlHead" />
    <br>
    <div class="box-footer">
        <table class="button-table">
            <tr>
                <td class="bottom-first">
                    <button type="button"
                            class="button-dark"
                            :disabled="curPlan == 0"
                            @click="prevClicked()">
                        &lt; Prev
                    </button>
                </td>
                <td class="bottom-last">
                    <button type="button"
                            :disabled="curPlan == lastPlan"
                            @click="nextClicked()">
                        Next &gt;
                    </button>
                </td>
            </tr>
            <tr v-if="showPrint">
                <td colspan="2"
                    class="bottom-button">
                    <button type="button"
                            class="button-light"
                            @click="printClicked()">
                        Print <i class="icon-printer" />
                    </button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, ref, computed, inject } from 'vue';
    import relapsePreventionPlan from './RelapsePreventionPlan.vue';

    const props = defineProps({
        modelValue: {
            type: Array,
            default: null
        },
        patientId: {
            type: Number,
            default: 0
        },
        goalPlanId: {
            type: Number,
            default: 0
        },
        editState: {
            type: Number,
            default: 0
        },
        componentKey: {
            type: Number,
            default: 0
        },
        hidePrint: {
            type: Boolean,
            default: false
        },
        urlHead: {
            type: String,
            default: null
        },
       
    });

    const curPlan = inject('curPlan', ref(0));
    const setCurrentRelapsePage = inject('setCurrentRelapsePage');
    const emit = defineEmits(['update:modelValue']);

    const relapsePreventionPlans = computed({
        get: () => props.modelValue,
        set: newValue => emit("update:modelValue", newValue)
    });

    const lastPlan = computed(() => relapsePreventionPlans.value.length - 1);
    const pageKey = computed(() => `page-key-${curPlan.value}-${props.componentKey}`);
    const showPrint = computed(() => props.goalPlanId != 0 && !props.hidePrint);

    

    function prevClicked() {
        if (curPlan.value > 0) {
            setRelapsePage(curPlan.value - 1);
        }
    }

    function nextClicked() {
        if (curPlan.value < lastPlan.value) {
            setRelapsePage(curPlan.value + 1);
        }
    }

    function setRelapsePage(pageValue) {
        if (setCurrentRelapsePage) {
            setCurrentRelapsePage(pageValue);
        } else {
            setLocalRelapsePage(pageValue);
        }
        
    }

    function setLocalRelapsePage(pageValue) {
        curPlan.value = pageValue;
    }

    function printClicked() {
        window.open(`/${props.urlHead}/RelapsePreventionPlanPrintable?goalPlanId=${props.goalPlanId}`, "_blank");
    }
</script>

<style scoped>
    .padded-row {
        margin-top: var(--between-elements-padding);
    }

</style>
